module.exports = __webpack_public_path__ + "static/media/math.a992e7a6.png";